<cache-date></cache-date>

<br><br>

<div class="row">
	<div class="col-md-12">
		<chart [data]="chart.data" [options]="chart.options" [sextant]="'chart'"></chart>
	</div>
</div>

<hr><br>


<div *ngIf="totalRec && totalRec > 0" [sextant]="'total1'">
	Всего: {{ totalRec }} <br>
	Оплаченных: {{ totalPaidRec }} <br>
	Неоплаченных: {{ totalFailRec }} <br>
</div>

<br>
<table *ngIf="totalRec && totalRec > 0" class="table" [sextant]="'total2'">
	<thead>
		<th></th>
		<th>{{ 'adminstat.common.Currency' | translate }}</th>
		<th>{{ 'adminstat.common.total' | translate }}</th>
	</thead>
	
	<tbody>
		<ng-container *ngFor="let currency of money | keys">
			<tr *ngIf="money[currency] && money[currency] > 0">
				<td></td>

				<td>
					{{ helper.currencyLabels[currency] }}
				</td>

				<td>
					{{ money[currency] ? helper.convertAmountToDollar(money[currency], currency) : 0 }}
				</td>
			</tr>
		</ng-container>
	</tbody>
</table>

<br>

<ngb-pagination
		*ngIf="stats && stats.length > 0"
		[collectionSize]="totalRec / 100"
		[maxSize]="10"
		[pageSize]="1"
		[(page)]="currentPage"
		[boundaryLinks]="true"
		(pageChange)="onPageChange()"
></ngb-pagination>

<br>

<loading [isLoad]="loader"></loading>
<table class="table" *ngIf="!loader" [sextant]="'stats'">
	<thead>
		<tr>
			<th></th>
			<th>{{ 'adminstat.common.Date' | translate }}</th>
			<th>{{ 'adminstat.common.language' | translate }}</th>
			<th>{{ 'adminstat.other.error' | translate }}</th>
			<th>{{ 'adminstat.common.Money' | translate }}</th>
			<th>{{ 'adminstat.filterForm.processorType' | translate }}</th>
			<th>{{ 'adminstat.common.Site' | translate }}</th>
		</tr>
	</thead>
	
	<tbody>
		<tr *ngFor="let stat of stats">
			<td [ngStyle]="{ 'background-color': stat.status == 'paid' ? 'green' : 'red' }"></td>
	
			<td>
				{{ stat.time }}
			</td>
	
			<td>
				{{ stat.lang || '' }}
			</td>
	
			<td>
				{{ stat.error_code || '' }}  {{ stat.error_text || '' }}
			</td>
	
			<td>
				{{ stat.moneyCount ? helper.convertAmountToDollar(stat.moneyCount, stat.currency) : '' }}
			</td>
	
			<td>
				{{ stat.processorType || '' }}
			</td>
	
			<td>
				<a *ngIf="stat.site" [href]="'http://' + stat.site" target="_blank" rel="noreferrer">{{ stat.site }}</a>
			</td>
		</tr>
	</tbody>
</table>
